import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@chakra-ui/react';
const RFTooltipInnerFC = ({ msg }) => {
    return msg ? (_jsx(Box, { bg: 'white', border: `1px solid`, borderColor: 'border', borderRadius: '4px', children: _jsx(Box, { p: '6px 10px', color: 'bodyText', fontSize: '14px', maxW: '360px', children: msg }) })) : null;
};
export const RFTooltipInner = RFTooltipInnerFC;
//# sourceMappingURL=RFTooltipInner.js.map